import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import PasswordInput from './PasswordInput';

export default class PasswordInputExample extends Component {

  state = {
    value: 'my secret password',
  };

  onChange = e => this.setState(e.target.value);

  onChangePassword = e => this.setState({ value: e.target.value });

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={PasswordInput.defaultProps} propTypes={PasswordInput.propTypes} propValues={this.state} onChange={this.onChange}/>
        <PasswordInput {...this.state} onChange={this.onChangePassword}/>
        <SourceCode querySelector=".password-input-example .core-password-input"/>
      </Example>
    );
  }

}
